import { useTranslation } from 'react-i18next';

import { faArrowRight, faSparkles } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { clsx } from 'clsx';

import { Chip } from '@spacefill/uikit/src/components/Chip';

const AiChatChoice = ({ number, label, isRecommended, isSelected, onSelect, disabled }) => {
    const { t } = useTranslation();

    return (
        <button
            type='button'
            aria-pressed={isSelected}
            onClick={onSelect}
            disabled={disabled}
            className={clsx(
                'group flex w-full cursor-pointer items-center gap-3 rounded-lg px-2 py-1.5 text-left text-[13px] text-slate-900 transition-colors disabled:cursor-not-allowed disabled:opacity-50',
                isSelected ? 'bg-lime-100' : 'hover:bg-gray-50'
            )}
        >
            <span
                className={clsx(
                    'flex size-6 shrink-0 items-center justify-center rounded-md text-xs',
                    isSelected ? 'bg-lime-300 text-lime-900' : 'bg-gray-100 text-gray-500'
                )}
            >
                {number}
            </span>
            <span className='flex min-w-0 flex-1 flex-wrap items-center gap-2'>
                <span className='wrap-anywhere'>{label}</span>
                {isRecommended && (
                    <Chip
                        variant='colorful'
                        color='green'
                        size='small'
                    >
                        <FontAwesomeIcon
                            icon={faSparkles}
                            className='mr-1'
                        />
                        {t('Suggested')}
                    </Chip>
                )}
            </span>
            <FontAwesomeIcon
                icon={faArrowRight}
                className={clsx('shrink-0 text-gray-400', !isSelected && 'invisible group-hover:visible')}
            />
        </button>
    );
};

export { AiChatChoice };
